import { combineReducers } from 'redux';
import loadingStage from './loadingStage';
import interactive from './interactive';
import geo from './geo';
import user from './user';
import skin from './skin';
import query from './query';
import footer from './footer';
import menu from './menu';

export default combineReducers({
  loadingStage,
  interactive,
  geo,
  user,
  skin,
  query,
  footer,
  menu,
});
